import { render, staticRenderFns } from "./zencourse.vue?vue&type=template&id=1a108db4"
import script from "./zencourse.vue?vue&type=script&lang=js"
export * from "./zencourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports